<template>
  <div
    class="uk-grid-small"
    uk-grid
  >
    <div
      v-if="isCompanyRole"
      class="uk-width-1-2@s uk-width-1-3@l"
    >
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'green'"
        :data="String(employeeCounts.new || 0)"
        :subtitle="'Karyawan'"
        :status="'Baru'"
        :route-name="'Employee'"
        :query-params="{ status: 'new' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-3@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'green'"
        :data="String(employeeCounts.active || 0)"
        :subtitle="isCompanyRole ? 'Karyawan' : 'Peserta'"
        :status="'Aktif'"
        :route-name="'Employee'"
        :query-params="{ status: 'active' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-3@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'red'"
        :data="String(employeeCounts.inactive || 0)"
        :subtitle="isCompanyRole ? 'Karyawan' : 'Peserta'"
        :status="'Tidak Aktif'"
        :route-name="'Employee'"
        :query-params="{ status: 'inactive' }"
      />
    </div>

    <div
      v-if="!isCompanyRole"
      class="uk-width-1-2@s uk-width-1-3@l"
    >
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'green'"
        :data="String(employeeCounts.new || 0)"
        :subtitle="'Peserta'"
        :status="'Baru'"
        :route-name="'Employee'"
        :query-params="{ status: 'new' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-3@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'grey'"
        :data="String(employeeCounts.freeze || 0)"
        :subtitle="isCompanyRole ? 'Karyawan' : 'Peserta'"
        :status="'Freeze'"
        :route-name="'Employee'"
        :query-params="{ status: 'freeze' }"
      />
    </div>
  </div>
</template>

<script>
import CardStatus from '@/components/globals/card/CardStatus'

export default {
  components: {
    CardStatus
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean
    },
    isCompanyRole: {
      required: false,
      type: Boolean,
      default: false
    },
    employeeCounts: {
      required: false,
      type: Object,
      default: () => ({})
    }
  }
}
</script>
